/**
 * Labstep
 *
 * @module components/Filter/User/Active/Post
 * @desc Active filter component for user
 */

import { FilterUserActiveLabel as RemoveLabel } from 'labstep-web/components/Filter/User/Active/Label';
import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { User } from 'labstep-web/models/user.model';
import type React from 'react';
import { getAuthorOrAssigneeGuid } from './utils';

export const FilterUserActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const { guid, type } = getAuthorOrAssigneeGuid(node);
  if (!guid) {
    return null;
  }
  return (
    <EntityReadEntityContainer
      entityName={User.entityName}
      guid={guid}
    >
      {({ entity }): React.ReactElement | null =>
        entity ? (
          <RemoveLabel
            user={entity}
            onRemoveClick={onRemoveClick}
            type={type}
          />
        ) : null
      }
    </EntityReadEntityContainer>
  );
};
